// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:960px){.mobile-email-tab-wrapper{height:100vh}}.mobile-email-tab-wrapper .v-tab{background-color:#f4f4f4;color:#6d6d6d;font-size:14px;text-transform:none}.mobile-email-tab-wrapper .v-tab:before{background-color:#fff}.mobile-email-tab-wrapper .v-tab--active{background-color:#fff;border:1px solid #e7e7e7;color:#000!important}.mobile-email-tab-wrapper .v-tab--active :before{background-color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
